import React from "react";
import { Star } from "lucide-react";

/**
 * Reusable star display. For interactive input use `interactive=true` + onChange.
 */
const ReviewStars = ({ value = 0, size = 16, interactive = false, onChange, label }) => {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div
      className={`inline-flex items-center gap-1 ${interactive ? "cursor-pointer" : ""}`}
      role={interactive ? "radiogroup" : "img"}
      aria-label={label || `Rated ${value} out of 5`}
    >
      {stars.map((s) => {
        const filled = value >= s;
        const half = !filled && value >= s - 0.5;
        const inner = (
          <Star
            style={{ width: size, height: size }}
            strokeWidth={1.5}
            className={filled || half ? "text-[var(--copper)]" : "text-[var(--sand)]"}
            fill={filled ? "currentColor" : "none"}
          />
        );
        if (!interactive) return <span key={s}>{inner}</span>;
        return (
          <button
            key={s}
            type="button"
            onClick={() => onChange?.(s)}
            aria-label={`${s} star${s > 1 ? "s" : ""}`}
            data-testid={`star-${s}`}
            className="focus:outline-none focus:ring-1 focus:ring-[var(--copper)] rounded-sm"
          >
            {inner}
          </button>
        );
      })}
    </div>
  );
};

export default ReviewStars;
